import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { type Keyword } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { initialValuesKeyword, validationSchemaKeyword } from "./KeywordCommon"
import { useCreateKeyword } from "../../hooks/keywords"
import KeywordForm from "./KeywordForm"

export default function KeywordCreate() {
  const createKeyword = useCreateKeyword()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesKeyword(), [])
  const validationSchema = useMemo(() => validationSchemaKeyword(), [])

  useBreadcrumbs([{ label: "Keywords", href: "/keywords/keywords" }, { label: "Creazione Keywords" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova keyword</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createKeyword.mutateAsync(values as Keyword).then((keyword: Keyword) => {
                navigate(`/keywords/keywords/${keyword.id}`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <KeywordForm />
                </Container>
                <BottomFormFixed url="/keywords/keywords" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
